import { Component, OnInit, NO_ERRORS_SCHEMA, EventEmitter, Output, ViewEncapsulation, Input, computed, signal, inject } from '@angular/core';
import { ImageModule } from 'primeng/image';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { HelperService } from '../../../shared/services/helper.service';
import { StorageService } from '../../../shared/services/storage.service';
import { SearchMarketService } from '../../../shared/services/search-market.service';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from '../../../shared/services/auth.service';
import { Store } from '@ngrx/store';
import { Location , CommonModule } from '@angular/common';
import { getSessionUser, getSessionFirmAddress, getSessionFirmName } from '../../../store/user/user.selector';
import { SessionUser, UserClientVm } from '../../../store/user/user.interface';
import { Observable } from 'rxjs';
import { UserService } from '../../../shared/services/user.service';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { BadgeModule } from 'primeng/badge';
import { ReviewerService } from '../../../shared/services/reviewer.service';
import { Tenant } from '../../../store/reviewer/reviewer.interface';
import { EmittersService } from '../../../shared/services/emitters.service';
import { constants, UserRoles } from '../../../shared/constants/constants';
import { DocumentService } from '../../../shared/services/document-service';
import { Router, RouterModule } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { MultiSelectComponent } from './select-search-markets/multi-select.component';
import { ConfigurationService } from '../../../shared/services/configuration.service';
import { environment } from '../../../../environments/environment';
import { PipesModule } from '../../../shared/pipes/pipes.module';
import { ClientPortalService } from '../../../shared/services/client-portal.service';
import { FirmContextService } from '../../../shared/services/firm-context.service';
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'app-header',
  standalone: true,
  // MP-5643: FormsModule is required for the child-firm switcher's ngModel
  // binding. NOTE it also activates the pre-existing `[(ngModel)]` on the
  // reviewer tenant dropdown below, which NO_ERRORS_SCHEMA has been silently
  // swallowing - worth a QA look on the reviewer header.
  imports: [FormsModule, DividerModule, ImageModule, MultiSelectModule, ButtonModule, DropdownModule, AvatarModule, AvatarGroupModule, CommonModule, MenuModule, ScrollPanelModule, BadgeModule, RouterModule,TooltipModule, MultiSelectComponent, PipesModule],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  schemas: [NO_ERRORS_SCHEMA]
})
export class HeaderComponent implements OnInit {

  /**
   * MP-5643 - the FM child-context switcher.
   *
   * Exposed as the service's own signals so the template and the interceptor
   * can never disagree about which child is active.
   */
  private readonly firmContext = inject(FirmContextService);
  readonly childFirms = this.firmContext.children;
  readonly selectedChildFirmId = this.firmContext.selectedChildId;
  readonly hasFirmSwitcher = this.firmContext.hasSwitcher;

  /** MP-5643: only a ROOT-attached user may switch child context. */
  get canSwitchChildFirm(): boolean {
    return this.userService.isFamilyRootUser();
  }
  @Output() toggleSideNav: EventEmitter<void> = new EventEmitter<void>();
  @Input() from: string = 'dashboard';
  items: MenuItem[] | undefined;

  searchFirm: any[] | undefined;
  searchMarkets: Array<any> = [];
  form1: any = {selectedSearchMarkets:[]};
  selectedSearchMarkets:any=[];
  selectedCity: any;
  userName: string = '';
  firmName$: Observable<string>;
  firmAddress$: Observable<string>;
  userRole: string = '';
  reviewerTenants: any[] = [];
  notifications: any = [];
  selectedTenant:any = null;
  firmLogo!: string;
  appLogo!: string;
  /**
   * MP-5646: the logo box, from the brand profile.
   *
   * The template hardcoded `isPwcEnabled ? '90' : '127'` - a two-brand ternary
   * with no room for a third. Mplace's wordmark is 244x73 (ratio 3.342), so
   * forcing it into staftr's 127x62 box squashed it horizontally. staftr's own
   * logo.png IS exactly 127x62, which is why only Mplace looked stretched.
   *
   * An environment that declares no dimensions falls back to the original
   * ternary, so staftr and pwc render exactly as before.
   */
  appLogoWidth!: string;
  appLogoHeight!: string;
  isPwcEnabled = false;
  isResponsive = false;
  /** MP-5750: client-portal session. Firm name and group name come from the portal session, not the store. */
  readonly isClientPortalUser = signal(false);
  readonly clientFirmName = computed(() => this.clientPortalService.firmName());
  readonly clientGroupName = computed(() => this.clientPortalService.clientGroupName());
  readonly clientUserName = computed(() => this.clientPortalService.userName());
  readonly accountMenuItems = signal<MenuItem[]>([]);

  constructor(public helperService: HelperService, private userService: UserService,
    private searchMarketService: SearchMarketService, private storageService: StorageService,
    private authService: AuthService, private store: Store<SessionUser>,
    private cookieService: CookieService, private location: Location,
    private documentService: DocumentService,
    private emitterService: EmittersService, private reviewerService: ReviewerService,
    private router: Router, private emittersService: EmittersService, private configurationService: ConfigurationService,
    private clientPortalService: ClientPortalService) {
      
    this.firmName$ = this.store.select(getSessionFirmName);
    this.firmAddress$ = this.store.select(getSessionFirmAddress);
    this.userRole = this.userService.getUserRole();
    this.appLogo = this.helperService.getLogo();
    this.appLogoWidth = this.helperService.getLogoWidth();
    this.appLogoHeight = this.helperService.getLogoHeight();
    this.isClientPortalUser.set(this.clientPortalService.isClientPortalUser());
    if (this.userRole === UserRoles.reviewer) {
      this.tenantSelected(this.storageService.getTenant())
      this.getReviewerTenants();
    }
  }
  
  isMobile = this.cookieService.get('isMobile') === 'true';
  isSideNavOpen: boolean = !this.isMobile;

  async ngOnInit() {
    this.checkResponsive();
    const user = this.userService.getSessionUser();
    this.isPwcEnabled = this.configurationService.getPwcFlag();
    if (this.isClientPortalUser()) {
      // MP-5750: no search markets (firms/... answers 403 for a CLIENT) and no
      // document logo (documents/... answers 403 too); the name comes from the session.
      this.accountMenuItems.set(this.buildAccountMenuItems());
      return;
    }
    this.firmLogo =  this.documentService.getDocumentPathById(user?.firm?.logo || '') || '';
    if (this.userRole === constants.userRoles.reviewer) {
      this.getNotifications();
    }
    else {
      /**
       * MP-5643: a childless firm answers with an empty `children` array, so
       * this is a no-op for Staftr and PWC - no dropdown, no header change.
       * Never rejects, so a failure cannot stop the shell rendering.
       */
      /**
       * Only a ROOT-attached user gets a family to switch within. A
       * child-attached user (PM, or a legacy child-attached FM) is scoped to
       * their own firm, so the context is cleared rather than loaded - which
       * also discards any stale selection left in storage by a previous user.
       */
      if (this.userService.isFamilyRootUser()) {
        await this.firmContext.loadFamily();
      } else {
        this.firmContext.clear();
      }

      /**
       * Search markets are PARENT-OWNED taxonomy: `searchMarketRepo.list`
       * runs `taxonomyScope.rootScopedQuery`, so whichever firm in the family
       * is named here resolves to the root and returns the same set. The
       * firm's own id is therefore correct for a root FM, a child FM and a
       * standalone firm alike - verified against QA data, where the root has
       * 2 markets and a child's raw query has 0 but the API returns the root's
       * 2 either way.
       *
       * Awaited behind `loadFamily()` so the child selection is settled before
       * anything else in this method depends on it.
       */
      this.searchMarketService.getFirmSearchMarkets(user.firm._id).subscribe({
        next: (searchMarkets) => {
          this.searchMarkets = searchMarkets.filter((e: any) => e.isActive);
          if(this.searchMarkets.length){
            const searchMarketIds = this.searchMarkets.map((s:any) => s._id);
            this.storageService.setSelectedSearchMarkets(searchMarketIds);
            this.selectedSearchMarkets =  searchMarketIds;
            this.emitterService.searchMarketSelectorEmitter.emit();
          }
        }
      })
    }
  }

  /**
   * MP-5643: switch the acting child firm.
   *
   * Reloads in place rather than emitting a context-change event, because the
   * ticket's requirement is that existing project / staff / report screens
   * follow the selection with ZERO per-screen changes. Every request carries
   * the new child through `X-Tenant-Id`, so a reload is what makes all of
   * them refetch without each one learning about the switcher.
   */
  onChangeChildFirm(childFirmId: string): void {
    if (!childFirmId || childFirmId === this.selectedChildFirmId()) {
      return;
    }

    this.firmContext.select(childFirmId);
    window.location.reload();
  }

  checkResponsive(){
    this.isResponsive = window.innerWidth < 768;
  }

  /** Account menu for a client-portal user: change password (existing flow) and logout. */
  private buildAccountMenuItems(): MenuItem[] {
    return [
      {
        label: 'Change Password',
        icon: 'pi pi-lock',
        command: () => this.router.navigateByUrl(constants.clientPortal.changePasswordUrl)
      },
      {
        label: 'Logout',
        icon: 'pi pi-sign-out',
        command: () => this.logout()
      }
    ];
  }

  getNotifications(){
    this.reviewerService.getNotificationHistory().subscribe((resp) => {
      this.notifications = resp;
      this.notifications.forEach((element: any) => {
        element.readMore = true;
      });
    })
  }

  toggleNotification(menu: any) {
    console.log(menu);
  }

  sideNavToggle(): void {
    this.toggleSideNav.emit();
  }

  getReviewerTenants() {
    let tenants = this.reviewerService.getReviewerTenants();
    tenants = tenants.filter((tenant) => tenant.reviewerStatus !== constants.userVerificationStatus.incomplete);
    const selectedTenant = this.storageService.getTenant();
    tenants.map((tenant: any) => {
      let t = {
        ...tenant,
        logo: this.documentService.getDocumentPathById(tenant.firm.logo)
      };

      if(t._id === selectedTenant._id){
        this.selectedTenant = t;
      } else {
        this.reviewerTenants.push(t);
      }
    })
    this.reviewerTenants.unshift(this.selectedTenant);
  }

  onChangeTenant(event: any){
    this.tenantSelected(event);
    window.location.reload();
  }

  tenantSelected(event: any) {
    this.selectedTenant = event;
    this.storageService.setTenant(event);
  }

  searchMarketsSelected(event: any) {
    if(event){
      this.storageService.setSelectedSearchMarkets(event);
      this.emitterService.searchMarketSelectorEmitter.emit(event);
    }
  }

  getUnreadNotificationCount(){
    if(this.notifications.length){
      return this.notifications.filter((n: any) => !n.isRead).length;
    }
    return 0;
  }

  markRead($event: Event, item: any){
    this.reviewerService.updateNotificationHistory({id: item._id}, 'read').subscribe(() => {
      item.isRead = true;
    });
  }

  readMore($event: Event, item: any){
    $event.stopPropagation();
    item.readMore = !item.readMore;
    if(!item.isRead){
      this.reviewerService.updateNotificationHistory({id: item._id}, 'read').subscribe(() => {
        item.isRead = true;
      });
    }
  }

  mapLogoUrl(id: string) {
    return this.reviewerService.mapFirmLogoUrl(id);
  }

  logout(): void {
    this.authService.logout();
  }

  goToDashboard() {
    if (this.isClientPortalUser()) {
      this.router.navigateByUrl(constants.clientPortal.homeUrl);
      return;
    }
    this.router.navigate(['/reviewer/dashboard']);
    if(this.location.path() === '/reviewer/dashboard'){
      this.emitterService.todoListEmitter.emit();
    }
  }

  tenantNameForDropdown(tenantName: any): string {
    return (tenantName.slice(0, 27) + (tenantName.length > 27 ? '...' : ''));
  }
 
  breakAddress(address: string, chunkSize: number = 50): string[] {
    if (!address) return [];
    // If the address is longer than 47 characters, truncate and add ellipsis
    const truncatedAddress = address.length > 47 ? address.slice(0, 47) + '...' : address;
    return Array.from({ length: Math.ceil(truncatedAddress.length / chunkSize) }, (_, i) => 
      truncatedAddress.slice(i * chunkSize, (i + 1) * chunkSize)
    );
  }
}
